import { WORK_MODE_OPTIONS } from 'utils/workMode';

interface Option {
  label: string;
  value: string;
  description?: string;
}

interface Question {
  id: string;
  title: string;
  type: 'radio' | 'checkbox';
  options: Option[];
  optionsLayout: 'list' | 'grid';
  optionDisplayStyle?: 'default' | 'coreResponsibilities';
}

export function formatApiResponseToQuestions(apiResponse: any): Question[] {
  // Map employment type options
  const employmentTypeOptions = [
    { label: 'Full-time', value: 'fulltime' },
    { label: 'Part-time', value: 'parttime' },
    { label: 'Contract', value: 'contract' },
    { label: 'Internship', value: 'internship' },
  ];

  // Map experience level options
  const experienceLevelOptions = [
    { label: 'Entry-Level', value: 'entry' },
    { label: 'Associate', value: 'associate' },
    { label: 'Mid-Level', value: 'mid' },
    { label: 'Senior/Executive Level', value: 'senior' },
  ];

  // Map years of experience options
  const yearsOfExperienceOptions = [
    { label: '0–1 years', value: '0_1' },
    { label: '1–3 years', value: '1_3' },
    { label: '3–5 years', value: '3_5' },
    { label: '6–8 years', value: '6_8' },
    { label: '8–10 years', value: '8_10' },
    { label: '10+ years', value: 'OVER_10' },
  ];

  // Map work environment options
  const workEnvironmentOptions = [
    { label: 'Freelance', value: 'freelance' },
    { label: 'Startup', value: 'startup' },
    { label: 'Growing Business', value: 'growing_business' },
    { label: 'Established Organisation', value: 'established_organisation' },
    { label: 'Large Corporate', value: 'large_corporations' },
    { label: 'Not important', value: 'not_important' },
  ];

  const coreResponsibilitiesOptions: Option[] = [];
  const coreResponsibilitiesData = apiResponse?.core_responsibilities || {};
  let crKey = 1;
  while (coreResponsibilitiesData[`responsibility${crKey}`]) {
    const label = coreResponsibilitiesData[`responsibility${crKey}`];
    const description = coreResponsibilitiesData[`description${crKey}`];
    if (label) {
      coreResponsibilitiesOptions.push({
        label,
        description: description || '',
        value: label.toLowerCase().replace(/\s+/g, '_'),
      });
    }
    crKey++;
  }


  return [
    {
      id: 'typeOfEmployment',
      title: 'Type of Employment\nWhat type of employment is this?',
      type: 'radio',
      options: employmentTypeOptions,
      optionsLayout: 'list',
      optionDisplayStyle: 'default',
    },
    {
      id: 'experienceLevel',
      title: 'Experience Level\nChoose the appropriate level of experience for the role:',
      type: 'radio',
      options: experienceLevelOptions,
      optionsLayout: 'list',
      optionDisplayStyle: 'default',
    },
    {
      id: 'workMode',
      title: 'Work Mode\nWhere will this role be carried out?',
      type: 'radio',
      options: WORK_MODE_OPTIONS,
      optionsLayout: 'list',
      optionDisplayStyle: 'default',
    },
    {
      id: 'yearsOfExperience',
      title: 'Years of Experience\nSelect the range of years of experience you are looking for:',
      type: 'radio',
      options: yearsOfExperienceOptions,
      optionsLayout: 'list',
      optionDisplayStyle: 'default',
    },
    {
      id: 'workEnvironment',
      title: 'Preferred Work Environment\nWhich work environments should the talent have experience in? (Select up to 2)',
      type: 'checkbox',
      options: workEnvironmentOptions,
      optionsLayout: 'grid',
      optionDisplayStyle: 'default',
    },
    {
      id: 'coreResponsibilities',
      title: 'Core Responsibilities\nWhich best define the primary focus of this role\'s day-to-day responsibilities? (Select all that apply)',
      type: 'checkbox',
      options: coreResponsibilitiesOptions,
      optionsLayout: 'grid',
      optionDisplayStyle: 'coreResponsibilities',
    },
  ];
}
